module.exports = __webpack_public_path__ + "img/happiness_positive.51ea790a.png";